/**
 * Shared bulk component (gap 1 PR 2, D-18 item 7). OPEN-213 reuses it; keep it free of domain
 * logic.
 *
 * The start date of a bulk change: the company's today or later. The API refuses earlier days
 * too; this only says so before the user asks. A caller's error (e.g. an API 400) wins.
 */

import React from 'react';
import { Input } from 'src/components/ui/input';

export function StartDateInput(p: {
  value: string;
  onChange(v: string): void;
  today: string;
  id?: string;
  error?: string | null;
}): React.JSX.Element {
  const fallbackId = React.useId();
  const id = p.id ?? fallbackId;
  // YYYY-MM-DD strings compare as dates.
  const early = p.value !== '' && p.value < p.today ? 'Start dates can be today or later.' : null;
  const error = p.error ?? early;
  return (
    <div>
      <label
        htmlFor={id}
        style={{ display: 'block', fontSize: '13px', fontWeight: 500, marginBottom: '4px' }}
      >
        Start date
      </label>
      <Input
        id={id}
        type="date"
        min={p.today}
        value={p.value}
        aria-invalid={error !== null}
        onChange={(e): void => p.onChange(e.target.value)}
      />
      {error !== null && (
        <p
          role="alert"
          style={{ fontSize: '13px', color: 'var(--color-danger)', marginTop: '4px' }}
        >
          {error}
        </p>
      )}
    </div>
  );
}
